import "core-js/modules/es6.function.name";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "component-shopNav",
    attrs: {
      "id": "shopNavBox"
    }
  }, [_c('div', {
    staticClass: "nav-box",
    class: {
      float: _vm.navFloat
    },
    attrs: {
      "id": "shopNavContent"
    }
  }, [_c('div', {
    staticClass: "nav-list"
  }, [_vm._l(_vm.navList, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "nav-item",
      class: {
        active: item.id == _vm.selectId
      },
      attrs: {
        "id": 'shopNav_' + item.id
      },
      on: {
        "click": function click($event) {
          $event.stopPropagation();
          return _vm.selectItem(item, 2);
        }
      }
    }, [_vm._v(_vm._s(item.name))]);
  }), _c('div', {
    staticClass: "search-btn",
    on: {
      "click": _vm.goSearch
    }
  }, [_vm._v("搜索")])], 2), _c('div', {
    staticClass: "nav-bar",
    style: {
      left: _vm.navLeft + 'px'
    }
  })])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };